import { siteConfig } from '../../lib/site-config'
import type { AppointmentBookingView } from './book-appointment-step'
import { ButtonLink } from '../ui/button'

export interface BookConfirmationStepProps {
  booking: AppointmentBookingView | null
  emailStatus?: string | null
}

export function BookConfirmationStep({
  booking,
  emailStatus,
}: Readonly<BookConfirmationStepProps>) {
  const confirmation = booking?.confirmation

  return (
    <section aria-labelledby="book-confirmation-heading" className="book-step-panel">
      <h2 id="book-confirmation-heading">Booking Confirmed</h2>
      {confirmation ? (
        <>
          <p>Your ceramic protection booking is confirmed with Autoglow.</p>
          <dl className="booking-confirmation-summary">
            <div>
              <dt>Booking reference</dt>
              <dd>{confirmation.publicReference}</dd>
            </div>
            <div>
              <dt>Protection</dt>
              <dd>{confirmation.protection} — {confirmation.productName}</dd>
            </div>
            <div>
              <dt>Add-ons</dt>
              <dd>{confirmation.addOnsLabel}</dd>
            </div>
            <div>
              <dt>Deposit</dt>
              <dd>{confirmation.depositPaidLabel}</dd>
            </div>
            <div>
              <dt>Appointment</dt>
              <dd>{confirmation.appointmentDate} at {confirmation.appointmentTime}</dd>
            </div>
            <div>
              <dt>Location</dt>
              <dd>{confirmation.location || siteConfig.address}</dd>
            </div>
          </dl>
          <p>{confirmation.remainingBalanceNote}</p>
          {emailStatus === 'sent' ? (
            <p role="status">A confirmation has been sent to {booking?.customer?.email}.</p>
          ) : null}
        </>
      ) : (
        <p>Your appointment details could not be loaded. Refresh this page or contact Autoglow.</p>
      )}
      <div className="hero-actions">
        <ButtonLink href="/" variant="ghost">Return Home</ButtonLink>
      </div>
    </section>
  )
}
